import { render, staticRenderFns } from "./FormsView.vue?vue&type=template&id=77dc5842&scoped=true&"
import script from "./FormsView.vue?vue&type=script&lang=js&"
export * from "./FormsView.vue?vue&type=script&lang=js&"
import style0 from "./FormsView.vue?vue&type=style&index=0&id=77dc5842&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77dc5842",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
